export const TRANSACTION_RECORD_FETCH = 'TRANSACTION/TRANSACTION_RECORD_FETCH';
export const TRANSACTION_RECORD_SUCCESS = 'TRANSACTION/TRANSACTION_RECORD_SUCCESS';

export const TRANSACTION_INFO_FETCH = 'TRANSACTION/TRANSACTION_INFO_FETCH';
export const TRANSACTION_INFO_SUCCESS = 'TRANSACTION/TRANSACTION_INFO_SUCCESS';
export const TRANSACTION_INFO_ERROR = 'TRANSACTION/TRANSACTION_INFO_ERROR';
